/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Compare_Event_Groups_Copy_Event_A_To_B_TitleInputs */



/**
* | output |
* | --- |
* | "Copy event from Group A to Group B" |
*
* @param {Compare_Event_Groups_Copy_Event_A_To_B_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const compare_event_groups_copy_event_a_to_b_title = /** @type {((inputs?: Compare_Event_Groups_Copy_Event_A_To_B_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Compare_Event_Groups_Copy_Event_A_To_B_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Copier l'événement du groupe A vers le groupe B")
	if (locale === "de") return /** @type {LocalizedString} */ ("Ereignis von Gruppe A nach Gruppe B kopieren")
	if (locale === "it") return /** @type {LocalizedString} */ ("Copia l'evento dal Gruppo A al Gruppo B")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Копирование события из группы A в группу B")
	if (locale === "es") return /** @type {LocalizedString} */ ("Copiar evento del Grupo A al Grupo B")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("将 A 组的事件复制到 B 组")
	if (locale === "ja") return /** @type {LocalizedString} */ ("グループAからグループBにイベントをコピー")
	if (locale === "hi") return /** @type {LocalizedString} */ ("ग्रुप A से ग्रुप B में इवेंट कॉपी करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Copiar evento do Grupo A para o Grupo B")
	return /** @type {LocalizedString} */ ("Copy event from Group A to Group B")
});